import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-details-payment-processors',
  templateUrl: './details-payment-processors.component.html',
  styleUrls: ['./details-payment-processors.component.scss']
})
export class DetailsPaymentProcessorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
